import { render, staticRenderFns } from "./CodeList.vue?vue&type=template&id=83bc3334&scoped=true"
import script from "./CodeList.vue?vue&type=script&lang=js"
export * from "./CodeList.vue?vue&type=script&lang=js"
import style0 from "./CodeList.vue?vue&type=style&index=0&id=83bc3334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bc3334",
  null
  
)

export default component.exports